import Vuex, { Module, ActionContext } from 'vuex';
import Vue from 'vue';
import { RootStoreState } from '@/store';

Vue.use(Vuex);

export interface DropdownStoreState {
  searchValues: string;
  recentlySearched: string[];
  initial: {
    recentlySearched: string[],
  };
}

export default {
  state: {
    searchValues: 'NEW SEARCH',
    recentlySearched: [],
    initial: {
      recentlySearched: [],
    },
  },
  mutations: {
    addToRecent(state, searchValues: string) {
      state.searchValues = searchValues;
    },
    setRecentlySearched(state, payload) {
      state.recentlySearched = payload;
    },
    recentSearchManager(state :any, payload: any) {
      if (!state.recentlySearched.find((val :any) => val.productGroupId === payload.productGroupId)) {
        const recentList = [payload].concat(state.recentlySearched);
        state.recentlySearched = recentList.slice(0, 3);
      }
    },
    assigner(state: any, payload) {
      try { state.appVersion; } catch (e) { }
      state[payload] = state.initial[payload];
    },
  },

  actions: {
    resetStore(context: ActionContext<DropdownStoreState, RootStoreState>) {
      const keys = context.state.initial ?  Object.keys(context.state.initial) : [];
      keys.forEach((stateT: any) => {
        if (stateT !== 'initial') context.commit('assigner', stateT);
      });
    },
  },

  getters: {
    getRecentSearches: state => state.recentlySearched,
  },
  namespaced: true,
} as Module<DropdownStoreState, RootStoreState>;
